import { DeliveryIcon, RefundsIcon, ReturnIcon, ShippingIcon } from "components/icons";
import { ShippingValue } from "data/data";
import React, { useEffect, useState } from "react";

interface  OutputPorp{
  color: string,
  name: string,
  desc?: string,
  svg: any,
}

interface DataPorp{
  data: ShippingValue[],
  slug?: string
}

const Policy = ({data, slug}:DataPorp) => {
  const [output, setOutput] = useState<OutputPorp[]> ([])
  let oo:OutputPorp[] = []
  useEffect(() => {
    setOutput([])
    for( let i = 0; i< data.length; i++){
      if(data[i].message){
        let obj:OutputPorp 
        if(data[i].type == 'shipping'){
          obj = {
            color: "bg-red-50",
            name: "Livraison gratuite",
            desc: data[i].message,
            svg: () =>  <ShippingIcon className="pr-1 w-10"/> ,
          };
          oo.push(obj)
          
        }
        if(data[i].type == 'return'){
          obj = {
            color: "bg-sky-50",
            name: "Très facile à retourner",
            desc: data[i].message,
            svg: () =>  <ReturnIcon className="pr-1 w-10"/> 
          }; 
          oo.push(obj)
        }
        if(data[i].type == 'delivery'){
          obj = {
            color: "bg-green-50",
            name: "Livraison nationale",
            desc: data[i].message,
            svg: () => <DeliveryIcon className="pr-1 w-10"/>
          };
          oo.push(obj)
        }
        if(data[i].type == 'refunds'){
          obj = {
            color: "bg-amber-50",
            name: "Politique de remboursement",
            desc: data[i].message,
            svg: () => <RefundsIcon className="pr-1 w-10"/>,
          }; 
          oo.push(obj)
        }
        setOutput(oo) ;


      }
  }
    
  }, [data])

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 relative">
      {output.map((item, index) => {
        return (
          <div
            key={index}
            className={`flex flex-col p-5 rounded-2xl ${item.color} dark:bg-opacity-90`}
          >
            <div ></div>
            <div className="mt-2.5">
              <p className="flex font-semibold text-slate-900"> {item.svg()} {item.name}</p>
              <p className="text-slate-500 mt-0.5 text-sm">{item.desc}</p>
            </div>
          </div>
        );
      })}

      {/* <div className="absolute inset-x-0 border-t top-1/2 -translate-y-1/2 border-slate-300"></div>
      <div className="absolute inset-y-0 border-l left-1/2 -translate-x-1/2 border-slate-300"></div> */}
    </div>
  );
};

export default Policy;
